import { render, staticRenderFns } from "./DilekceList.vue?vue&type=template&id=2827fc0a&scoped=true"
import script from "./DilekceList.vue?vue&type=script&lang=ts"
export * from "./DilekceList.vue?vue&type=script&lang=ts"
import style0 from "./DilekceList.vue?vue&type=style&index=0&id=2827fc0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827fc0a",
  null
  
)

export default component.exports